<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          @if (!inEditMode) {
            <strong>Add Colleague in account : {{activeAccount.account.accountName | titlecase}}</strong>
          }
          @if (inEditMode) {
            <strong>Editing Member : {{memberToEdit?.user?.name | titlecase}}</strong>
          }
          @if (!inEditMode) {
            <button mat-raised-button style="float: right; margin-right: 20px;" color="primary" (click)="inviteMultiple()">Invite Multiple</button>
          }
        </div>
        @if (accountStatus == 'UNVERIFIED') {
          <div class="card-body">
            <div class="comment-box">
              It appears that the team account {{activeAccount.account.accountName | titlecase}} you have created is still
              unverfiied. Kindly verify it to invite your colleagues in the team account.
              <div class="d-flex flex-row justify-content-center mt-3">
                <button mat-raised-button color="primary" (click)="verifyAccount()">Verify Account</button>
              </div>
            </div>
          </div>
        }
        @if (accountStatus == 'DELETED') {
          <div class="card-body">
            <div class="comment-box">
              It appears that the team account {{activeAccount.account.accountName | titlecase}} is in deleted state and
              in the process of removal.
            </div>
          </div>
        }
        @if (accountStatus == 'ACTIVE') {
          <div class="card-body" style="min-height: 40vh;">
            @if (!inEditMode) {
              <div class="comment-box">
                Add the mobile number of your colleague you want to invite. Select the authorization level she/he will have. They will receive message post invite.
              </div>
            }
            <app-render-custom-properties [customProperties]="customProperties" [formPresetData]="memberToEdit.customMemberAttributes" (formValue)="customFormValue($event)"></app-render-custom-properties>
            @if (inEditMode) {
              <div class="comment-box">
                Change the authorization level of the user and post the change, refresh the application to see the effect.
              </div>
            }
            <form [formGroup]="addEmployeeForm" (ngSubmit)="onSubmitInviteForm($event)" class="form" ngNativeValidate>
              @if (!inEditMode) {
                <div formGroupName="invitedUser">
                  <ngx-intl-tel-input style="width : 100%; margin-bottom : 20px;" placeholder="Enter Mobile Number of colleague you wish to invite"
                    [cssClass]="'iti__tel-input w-100 form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover rounded g-py-15 g-px-15'"
                    [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National"  name="registeredNumber" formControlName="registeredNumber">
                  </ngx-intl-tel-input>
                  @if (!getRegisteredNumberControl().valid && getRegisteredNumberControl().touched) {
                    <mat-error>
                      {{ getErrorInvitedUserNumber(getRegisteredNumberControl()) }}
                    </mat-error>
                  }
                  <!-- <mat-form-field class="form-element">
                  <input matInput name="registeredNumber" id="registeredNumber" placeholder="Enter Mobile Number of colleague you wish to invite"
                    (blur)=checkIfNotDuplicate()
                    formControlName="registeredNumber">
                    <mat-error
                      *ngIf="!getRegisteredNumberControl().valid && getRegisteredNumberControl().touched">
                      {{ getErrorInvitedUserNumber(getRegisteredNumberControl()) }}
                    </mat-error>
                  </mat-form-field> -->
                  @if (isNotDuplicateEmployee || inEditMode) {
                    <fieldset>
                      <!-- <mat-form-field class="form-element">
                      <input matInput name="name" id="name" placeholder="Enter Name of your colleague"
                        formControlName="name">
                        <mat-error
                          *ngIf="!addEmployeeForm.controls.invitedUser.controls.name.valid && addEmployeeForm.controls.invitedUser.controls.name.touched">
                          {{ getErrorInvitedUserName(addEmployeeForm.controls.invitedUser.controls.name) }}
                        </mat-error>
                      </mat-form-field> -->
                      <mat-form-field class="form-element">
                        <input matInput name="registeredEmail" id="registeredEmail"
                          placeholder="Enter official email id of colleague for {{activeAccount.account.accountName | titlecase}}"
                          formControlName="registeredEmail">
                          @if (!addEmployeeForm.controls.invitedUser.controls.registeredEmail.valid && addEmployeeForm.controls.invitedUser.controls.registeredEmail.touched) {
                            <mat-error
                              >
                              {{ getErrorInvitedUserEmail(addEmployeeForm.controls.invitedUser.controls.registeredEmail) }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </fieldset>
                    }
                  </div>
                }
                @if (isNotDuplicateEmployee || inEditMode) {
                  <div class="form-group">
                    <!-- <p style="margin-bottom : 40px;">
                    What Authorization Level you wish to assign to your colleague?
                    <mat-button-toggle-group name="invitedUserAuthorizationLevel" aria-label="invitedUserAuthorizationLevel"
                      formControlName="invitedUserAuthorizationLevel">
                      <mat-button-toggle *ngFor="let authorization of authorizations" [value]="authorization.value">
                      {{authorization.viewValue}}</mat-button-toggle>
                    </mat-button-toggle-group>
                  </p> -->
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Permissions</th>
                        <th>Super Admin</th>
                        <th>Admin</th>
                        <th>Manager</th>
                        <th>Member</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Manage Account</td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-x"></i></td>
                        <td><i class="bi bi-x"></i></td>
                        <td><i class="bi bi-x"></i></td>
                      </tr>
                      <tr>
                        <td>Add/Delete Users</td>
                        <td><i class="bi bi-check"></i></td>
                        <td>Can Request</td>
                        <td>Can Request</td>
                        <td><i class="bi bi-x"></i></td>
                      </tr>
                      <tr>
                        <td>Make Teams</td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-x"></i></td>
                      </tr>
                      <tr>
                        <td>View Data</td>
                        <td>Everyone</td>
                        <td>Everyone</td>
                        <td>Own & Reportees</td>
                        <td>Own</td>
                      </tr>
                      <tr>
                        <td>Edit Data</td>
                        <td>Everyone</td>
                        <td>Everyone</td>
                        <td>Own & Reportees</td>
                        <td>Own</td>
                      </tr>
                      <tr>
                        <td>Create Campaigns</td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-x"></i></td>
                      </tr>
                      <tr>
                        <td>Assign Leads & tasks</td>
                        <td><i class="bi bi-check"></i></td>
                        <td><i class="bi bi-check"></i></td>
                        <td>Reportees</td>
                        <td><i class="bi bi-x"></i></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td>
                          <mat-slide-toggle color="primary"
                            [checked]="addEmployeeForm.get('invitedUserAuthorizationLevel').value == 'SUPERADMIN'"
                          (change)="toggle('SUPERADMIN')"></mat-slide-toggle>
                        </td>
                        <td>
                          <mat-slide-toggle color="primary"
                            [checked]="addEmployeeForm.get('invitedUserAuthorizationLevel').value == 'ADMIN'"
                          (change)="toggle('ADMIN')"></mat-slide-toggle>
                        </td>
                        <td>
                          <mat-slide-toggle color="primary"
                            [checked]="addEmployeeForm.get('invitedUserAuthorizationLevel').value == 'MANAGER'"
                          (change)="toggle('MANAGER')"></mat-slide-toggle>
                        </td>
                        <td>
                          <mat-slide-toggle color="primary"
                            [checked]="addEmployeeForm.get('invitedUserAuthorizationLevel').value == 'MEMBER'"
                          (change)="toggle('MEMBER')"></mat-slide-toggle>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <ng-select [items]="authorizations" [selectOnTab]="true"
                  bindLabel="viewValue" bindValue="value" placeholder="Enter Authorization Level"
                  formControlName="invitedUserAuthorizationLevel">
                </ng-select> -->
              </div>
            }
            <!-- <mat-form-field class="form-element">
            <input matInput name="invitedUserAuthorizationLevel" id="invitedUserAuthorizationLevel"
              placeholder="Enter Authorization Level" formControlName="invitedUserAuthorizationLevel">
              <mat-error
                *ngIf="!addEmployeeForm.controls.invitedUserAuthorizationLevel.valid && addEmployeeForm.controls.invitedUserAuthorizationLevel.touched">
                {{ getErrorInvitedUserAuthorization(addEmployeeForm.controls.invitedUserAuthorizationLevel) }}
              </mat-error>
            </mat-form-field> -->
            <div class="d-flex justify-content-between bd-highlight mt-3">
              <button type="button" mat-raised-button (click)="onResetInviteUser()">Reset</button>
              <button type="submit" mat-raised-button color="primary"
              [disabled]="!addEmployeeForm.valid">Submit</button>
            </div>
          </form>
        </div>
      }
    </div>
  </div>
</div>
</div>